module.exports = __webpack_public_path__ + "img/logo.65d29e24.svg";